import { Container } from 'react-bootstrap';
import "../styles/navbar.css";
import axios from '../axios.jsx';
import { useNavigate} from 'react-router-dom';
import { Button} from 'react-bootstrap';


import bannerImage  from '../image/Banner.PNG';
import bannerImage2 from '../image/pic.PNG';
import {useAuth} from '../AuthContext';

export default function MainLayout({ children }) {
    const {user, logout } = useAuth();
    const navigate = useNavigate();

    const handlelogout = async () =>  {
      await axios.post('/login/logout', {
                  withCredentials: true,
                });
      
                logout();
      
              navigate('/')
          }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

      {/* ── Navbar ── */}
      <nav className="navbar-main d-flex align-items-center w-100 position-relative">
        <div className="navbar-logos">
          <img src={bannerImage}  alt="Gobernación" className="navbar-logo_1" />
          <div className="navbar-logo-divider" />
          <img src={bannerImage2} alt="PIC" className="navbar-logo" />
        </div>
        <div className="titulo-navbar">
          SISTEMA DE ALERTA TEMPRANA EN SALUD - AMAZONAS
        </div>
{user && (
  <Button className='btn_cerrar ms-auto me-3' onClick={handlelogout}>
    Cerrar Sesión
  </Button>
)}

      </nav>

      {/* ── Contenido principal (crece para llenar el espacio) ── */}
      {/* NUEVO: fluid (sin "lg") para que el contenedor use 100% del ancho
          en todos los breakpoints, en vez de topar en un max-width fijo
          a partir de la pantalla "lg". */}
      <div className="main-content" style={{ flex: 1 }}>
        <Container fluid>
          {children}
        </Container>
      </div>

      {/* ── Footer siempre al fondo ── */}
      <footer className="footer-main">
        <div className="footer-content">

          <div className="footer-section">
            <div className="footer-title">Aplicativo SAT</div>
            <div className="footer-sub">Vigilancia en salud publica y epidemiologia · 2026</div>
          </div>

          <div className="footer-section footer-center">
            <div className="footer-dev">
               Desarrollado por <strong>Ing. Mateo Soto</strong>
            </div>
            <div className="footer-links">
              <a href="tel:+573235763653"> +57 323 576 3653</a>
              <span className="footer-sep">·</span>
              <a href="mailto:mateo-soto@hotmail.com">✉️ mateo-soto@hotmail.com</a>
            </div>
          </div>

          <div className="footer-section footer-right">
            <div className="footer-copy">© 2026 VSP</div>
            <div className="footer-copy">Todos los derechos reservados</div>
          </div>

        </div>
      </footer>

    </div>
  );
}